<dk-ticker-card
  titleText="Potansiyel Müşteriler"
  total="51"
  [percentage]="8.5"
  contentClass="leads"
></dk-ticker-card>
